{
  "version": 1,
  "asset_id": "948bf917-3ceb-4356-bb8d-8b62e0696714",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/948bf917-3ceb-4356-bb8d-8b62e0696714/clip-img_0137.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/948bf917-3ceb-4356-bb8d-8b62e0696714/clip-img_0137.mp4",
  "original_filename": "clip-img_0137.mp4",
  "size": 521552,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T18:33:59Z"
}
